import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { TxKeyword, TxKwMsg } from '../../../_models';
import { NotificationService, TxMsgService, TxKeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-kw-msg-detail',
  templateUrl: './msg-detail.component.html',
  styleUrls: []
})
export class KwMsgDetailComponent implements OnInit {

  msgData: TxKwMsg = null;
  keyword: TxKeyword = null;
  loaded = false;
  loading = true;
  processing = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private txMsgSvc: TxMsgService,
    private keywordSvc: TxKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this template?")) {
      this.txMsgSvc.updateKwMsg(this.msgData).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Template updated successfully!", "Update Template");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update template, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/tx/kw-msg', this.keyword.id]);
  }

  private loadDetail(id){
    this.txMsgSvc.getKwMsg(id).subscribe(data => {
      this.msgData = data
      this.loaded = true;
      this.loading = false;
      this.loadKeyword(this.msgData.kid);
    });
  }

  loadKeyword(id){
    this.keywordSvc.getKeyword(id).subscribe(data => {
      this.keyword = data
    });
  }

}
